import { gql } from 'graphql-request';
import { z } from 'zod';
import { DatoAssetQuery, Query, SeoMetaTagValidation } from './datoCMS';

export const CaseThumbQuery = new Query(
	gql`
		slug
		smallDescription
		thumbMedia {
			${DatoAssetQuery}
		}
	`,
	z.object({
		slug: z.string(),
		smallDescription: z.string(),
		thumbMedia: DatoAssetQuery.validation
	})
);

const ServiceThumbQuery = new Query(
	gql`
		slug
		service
		thumbAsset {
			${DatoAssetQuery}
		}
	`,
	z.object({
		slug: z.string(),
		service: z.string(),
		thumbAsset: DatoAssetQuery.validation.nullish()
	})
);

export const BlogThumbQuery = new Query(
	gql`
		_createdAt
		slug
		title
		thumbMedia {
			${DatoAssetQuery}
		}
	`,
	z.object({
		_createdAt: z.string(),
		slug: z.string(),
		title: z.string(),
		thumbMedia: DatoAssetQuery.validation
	})
);

export const EmployeeQuery = new Query(
	gql`
		media {
			${DatoAssetQuery}
		}
		name
		title
		mail
		phone
		linkedin
	`,
	z.object({
		media: DatoAssetQuery.validation,
		name: z.string(),
		title: z.string(),
		mail: z.string(),
		phone: z.string().nullish(),
		linkedin: z.string().nullish()
	})
);

export const GlobalQuery = new Query(
	gql`
		query GlobalSettings {
			allContentPages(filter: { addToNavigation: { eq: "true" } }) {
				slug
				title
			}
			allServices {
				${ServiceThumbQuery}
			}
			allEmployees(first: "100") {
				${EmployeeQuery}
			}
			allCases(first: "8") {
				${CaseThumbQuery}
			}
			_allCasesMeta {
				count
			}
			allBlogs(first: "8") {
				${BlogThumbQuery}
			}
			_allBlogsMeta {
				count
			}

			_site {
				faviconMetaTags {
					tag
					content
					attributes
				}
			}

			footer {
				headline
				contact
			}
		}
	`,
	z.object({
		allContentPages: z.array(
			z.object({
				slug: z.string(),
				title: z.string()
			})
		),
		allServices: z.array(ServiceThumbQuery.validation),
		allEmployees: z.array(EmployeeQuery.validation),
		allCases: z.array(CaseThumbQuery.validation),
		allBlogs: z.array(BlogThumbQuery.validation),
		_allCasesMeta: z.object({
			count: z.number()
		}),
		_allBlogsMeta: z.object({
			count: z.number()
		}),
		_site: z.object({
			faviconMetaTags: z.array(SeoMetaTagValidation)
		}),
		footer: z.object({
			headline: z.string(),
			contact: z.string()
		})
	})
);

export type GlobalType = z.infer<typeof GlobalQuery.validation>;
export type ServiceThumbType = z.infer<typeof ServiceThumbQuery.validation>;
